var Autoplay = {
	program:[],
	current:0,
	initialized:false,
	isRunning:false,
	speechStatus:-1,
	baseIdent:null,
	labels:{},

	init: function() {
		AppEvent.on(SpeechManager, "SPEECH.FINISHED", Autoplay.speechFinished);
	},

	speechFinished: function() {
		//console.log("speech finished");
		if (Autoplay.postponed != undefined && SpeechManager.hasSpeech()) {
			player.go(Autoplay.postponed.command.params[0], parseFloat(Autoplay.postponed.command.params[1]), Autoplay.postponed.ry);
			Autoplay.postponed = undefined;
		}
	},

	skipSpeech: function() {
		player.go(Autoplay.postponed.command.params[0], parseFloat(Autoplay.postponed.command.params[1]), Autoplay.postponed.ry);
	},

	onPlaceLoad: function(place) {
		Autoplay.postponed = undefined;

		if (Autoplay.baseIdent == player.ident) return;

		if (Autoplay.isRunning) {

			//console.log("on place load");

			if (SpeechManager.hasSpeech()) {
				if (Autoplay.speechStatus == -1) {

					Autoplay.speechStatus = 1;
					Autoplay.speakAndGo(true);
					/*
					Dialog.select("", "<img src='assets/lector.png' style='float:left;margin-right:10px;'><br>Czy chcesz uruchomić lektora czytającego opisy miejsc ?", "", ["Tak", "Nie"], function(no) {
						if (no == 0) {
							Autoplay.speechStatus = 1;
							Autoplay.speakAndGo(true);
						} else {
							Autoplay.speechStatus = 0;
							Autoplay.speakAndGo(false);							
						}
					});
					*/

				} else if (Autoplay.speechStatus == 1) {
					Autoplay.speakAndGo(true);
				} else if (Autoplay.speechStatus == 0) {
					Autoplay.speakAndGo(false);
				}
			} else {
				console.log("next after load " + player.ident);
				Autoplay.next();
			}
		}

		Autoplay.baseIdent = player.ident;
	},

	speakAndGo: function(status) {
		if (status) {
			//SpeechManager.speak();
		}

		Autoplay.next();
	},

	start: function(ident, data) {
		if (!Autoplay.initialized) {
			AppEvent.on(player, "PLACE.LOADED", Autoplay.onPlaceLoad);
			Autoplay.initialized = true;

			$("#overlay").append(TPL.render("autoplay-ui", {"pdown": "on" + Events.pointer.down}));

			Autoplay.button = $("#aui_icon");
			Autoplay.stopbutton = $("#aui_back");
			Autoplay.skipbutton = $("#aui_skip");

			Autoplay.button.on(Events.pointer.down, Autoplay.toggle);
			Autoplay.stopbutton.on(Events.pointer.down, Autoplay.stop);
			Autoplay.skipbutton.on(Events.pointer.down, Autoplay.skipSpeech);
		}

		Autoplay.baseIdent = player.ident;
		//alert(data.properties.code);
		player.bottomBar(false);
		$("#autoplay_ui").show();

		Autoplay.program = Autoplay.compile(data.properties.code);
		AppEvent.trigger(player, "AUTOPLAY.STARTED", {});
		Autoplay.run();
	},

	compile: function(code) {
		var c = code.replace(/(\r\n|\n|\r)/gm,"");
		var commands = c.split(";");
		var command = "";
		var opcode = "";
		var params = [];

		var p = [];

		for(var i in commands) {
			command = commands[i].trim();

			var oe = command.indexOf(" ");
			params = [];

			if (oe != -1) {
				opcode = command.substr(0, oe).toLowerCase();
				params = command.substr(oe + 1).split(",");
			} else {
				opcode = command.toLowerCase();
			}

			p.push({"opcode":opcode, "params":params});
		}

		return p;
	},

	run: function() {
		Autoplay.current = 0;
		Autoplay.resume();
	},

	cycle: function() {
		var command;

		if (!Autoplay.isRunning) return;

		if (Autoplay.current >= Autoplay.program.length) {
			Autoplay.finished();
			return;
		}

		command = Autoplay.program[Autoplay.current];
		Autoplay.current ++;

		//console.log(command.opcode + " " + command.params[0] + " ...");

		switch (command.opcode) {
			case "e":
				Autoplay.labels[command.params[0]] = Autoplay.current;
				Autoplay.next();
			break;

			case "loop":
				Autoplay.current = Autoplay.labels[command.params[0]];
				Autoplay.next();
			break;

			case "s":
				setTimeout(function() {Autoplay.cycle();}, parseFloat(command.params[0]) * 1000);
			break;

			case "go":
				var ry = parseFloat(command.params[2]);
				if (ry == undefined || ry == null) ry = 0;

				if (SpeechManager.hasSpeech() && SpeechManager.speaks() && Autoplay.speechStatus == 1) {
					Autoplay.postponed = {"command": command, "ry": ry};
				} else {
					player.go(command.params[0], parseFloat(command.params[1]), ry);
				}
			break;

			case "rr":
			case "rl":
				//console.log(player.currentView.old2angle(command.params[0]));
				player.currentView.turnToAnd(player.currentView.old2angle(command.params[0]), command.params[1], 60, Autoplay.afterTurn);
				// player.currentView.turnTo(command.params[0], command.params[1]);
			break;

			case "rls":
			case "rrs":
				player.currentView.turnToAnd(player.currentView.old2angle(command.params[0]), command.params[1], parseFloat(command.params[2]) * 30, Autoplay.afterTurn);
			break;

			case "zi":
				player.currentView.zoomToAnd(parseFloat(command.params[0]) * 200, (command.params.length > 1 ? parseFloat(command.params[1]) * 1000 : 2000), Autoplay.cycle);
				//console.log(command.params);
//				setTimeout(function() {Autoplay.cycle();}, parseFloat(command.params[0]) * 1000);
			break;

			case "zo":
				player.currentView.zoomToAnd(parseFloat(command.params[0]) * (-200), (command.params.length > 1 ? parseFloat(command.params[1]) * 1000 : 2000), Autoplay.cycle);
//				setTimeout(function() {Autoplay.cycle();}, parseFloat(command.params[0]) * 1000);
			break;

			case "map":				
				if (command.params[0] == "2") {
					$("#mapinfo").addClass("hidden");
					mapInfo.disabled = true;
				} else {
					$("#mapinfo").removeClass("hidden");
					mapInfo.disabled = false;
				}
				Autoplay.cycle();
			break;

			case "lng":
			case "txt":
				if (command.opcode == "txt" || command.params[0] == player.lang) {
					
					if (command.opcode == "txt") $("#category_info").html(command.params[0]);
					else $("#category_info").html(command.params[1]);

					$("#category_info").css("opacity","1");
					Autoplay.next();

					setTimeout(function() {
						$("#category_info").css("opacity","0");
					}, 2000);
				} else {
					Autoplay.cycle();
				}
			break;

			default: 
				Autoplay.next();
		}

	},

	afterTurn: function() {
		Autoplay.next();
	},

	next: function() {
		setTimeout(function() {
			Autoplay.cycle();
		}, 1000);
	},

	finished: function() {
		player.bottomBar(true);
		$("#autoplay_ui").hide();
		AppEvent.trigger(Autoplay, "AUTOPLAY.FINISHED", {});
	},

	stop: function() {
		SpeechManager.speakTip("PLAYER.CLOSE", "TIPS");
		Autoplay.pause();
		Autoplay.finished();
	},

	toggle: function() {
		if (Autoplay.isRunning) Autoplay.pause(); 
		else Autoplay.resume();
	},

	pause: function() {
		if (Autoplay.isRunning) {
			Autoplay.isRunning = false;
			//player.bottomBar(true);
			Autoplay.button.html("<span>" + TPL.lng("autopilot.resume", "Wznów") + "</span><img src='assets/play.png'>");
			Autoplay.button.removeClass("aui_auto_running");

			player.currentView.stopTurning();
			//$("#autoplay_icon").hide();
			AppEvent.trigger(Autoplay, "AUTOPLAY.PAUSED", {});
		}
	},

	resume: function() {
		Autoplay.isRunning = true;
		//player.bottomBar(false);
		Autoplay.button.html("<span>" + TPL.lng("autopilot.stop", "Zatrzymaj") + "</span><img src='assets/pause.png'>");
		Autoplay.button.addClass("aui_auto_running");
		Autoplay.cycle();
		//$("#autoplay_icon").show();
		AppEvent.trigger(Autoplay, "AUTOPLAY.RESUMED", {});
	},

	running: function() {
		return Autoplay.isRunning;
	}

}

PluginManager.add(Autoplay);